import { useLocalizationContext } from '@im/react-localization';
import { createContext, useContext, useMemo } from 'react';
import { useIsAuthenticated } from '../auth';
import { useApiQuery } from '../query';
import { KenticoWidgetData } from './cms.widget.types';

/** Query for loggedout homepage and configuration*/
export function useLogOutConfig() {
  const { locale } = useLocalizationContext();
  const isAuthenticated = useIsAuthenticated();
  const query = useApiQuery<LogoutHomePageConfigTO>(
    `/cms-noauth/v1/loggedout-home`,
    { culture: locale },
    { enabled: !isAuthenticated },
    undefined,
    {
      isLogoutApi: true,
    }
  );
  return useMemo(() => {
    return {
      data: query.data,
      isLoading: query.isLoading,
    } as ILogoutConfigContext;
  }, [query.data, query.isLoading]);
}

/** context for logout config */
export const logoutContext = createContext<ILogoutConfigContext | undefined>(
  undefined
);

/** `Hook` to access logoutContextData.
 */
export function useLogoutContext(contextData?: ILogoutConfigContext) {
  const context = useContext(logoutContext);
  return context ?? { data: undefined, isLoading: true };
}

export type ILogoutConfigContext = {
  data: LogoutHomePageConfigTO | undefined;
  isLoading: boolean;
};

export type LogoutHomePageConfigTO = {
  absoluteUrl: string;
  errors: any;
  isLogoutEnabled: boolean;
  isPageAvailable: boolean;
  pageBuilder: KenticoWidgetData;
  pageTitle: string;
  renderAsReactPage: boolean;
  seoDescription: string;
  seoImage: string;
  seoTitle: string;
};
